import { HttpService } from '@src/api/common/HttpService';
import { UrlService } from '@src/api/common/UrlService';
import { CteApiUrl } from '@src/constants/BaseUrls';

type TechnologyType = {
  id: number;
};

export const TechnologyService = () => {
  const { HttpGet, HttpDelete, HttpPost } = HttpService();

  const GetTechnologyAll = async (query: string) => {
    const url = `${CteApiUrl}/api/v1/technology${query}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetTechnologyById = async (body: TechnologyType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/technology/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const CreateOrUpdateTechnology = async (body: any) => {
    const url = `${CteApiUrl}/api/v1/technology/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

  const LogicDeleteTechnologyById = async (body: TechnologyType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CteApiUrl}/api/v1/technology/detail${suffix}`;
    const response = await HttpDelete(url);
    return response;
  };

  return {
    GetTechnologyAll,
    GetTechnologyById,
    CreateOrUpdateTechnology,
    LogicDeleteTechnologyById,
  };
};
